import { useEffect, useState } from "react";

/**
 * Reactive media query.
 *
 * Used for layout SHAPE decisions that CSS alone cannot make — on a phone the
 * cart is a collapsible sheet rather than a pane, which changes the component
 * tree, not just its styling.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/**
 * Phone-shaped. Deliberately width-only: a small tablet in portrait still gets
 * the two-pane till, because the pane layout works from roughly 720px up.
 */
export function useIsPhone(): boolean {
  return useMediaQuery("(max-width: 719px)");
}
